import api from "../../api/api";
import { ENDPOINTS } from "../../api/endpoints";

export const useQuestionsApi = () => {
  const userId = 1;

  const getCategories = async () => {
    const res = await api.get("/api/Admin/GetQuestionMaster");
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  };

  const getQuestions = async () => {
    const res = await api.get(ENDPOINTS.getQuestions());
    return Array.isArray(res.data)
      ? res.data
      : res.data?.data || res.data?.questions || [];
  };

  const saveQuestion = async (data) => {
    const payload = {
      questionId: data.questionId || 0,
      questionText: data.questionText,
      answerText: data.answerText,
      userId,
      category: data.category,
      position: data.position || 0,
    };

    return api.post(ENDPOINTS.addOrUpdateQuestion(), payload);
  };
  const deleteQuestion = async (id) => {
    return api.delete(ENDPOINTS.deleteQuestion({ questionId: id, userId }));
  };

  const deleteCategory = async (id) => {
    return api.delete(`/api/Admin/DeleteQuestionMaster?questionId=${id}`);
  };

  return {
    getQuestions,
    saveQuestion,
    deleteQuestion,
    deleteCategory,
    getCategories,
  };
};
